import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './HttpRequest'

export default class AuthProvider extends HttpRequest {
  login (username, password) {
    this.setHeader(getAuthToken())
    return this.post('auth/login', { username, password })
  }
}
